"use strict";

export default function () {
    (function () {
        var overlay = document.getElementById("o-lightbox");
        var overlayImg = overlay.querySelector(".o-lightbox__img");
        var closeBtn = overlay.querySelector(".js-lightbox-close");

        function openLightbox(href, alt) {
            overlayImg.src = href;
            overlayImg.alt = alt || "";
            overlay.classList.add("is-open");
            overlay.setAttribute("aria-hidden", "false");
            document.body.style.overflow = "hidden";
        }
        function closeLightbox() {
            overlay.classList.remove("is-open");
            overlay.setAttribute("aria-hidden", "true");
            overlayImg.src = "";
            document.body.style.overflow = "";
        }

        document.querySelectorAll(".js-lightbox").forEach(function (el) {
            el.addEventListener("click", function (e) {
                e.preventDefault();
                var href = el.getAttribute("href") || el.dataset.full;
                var img = el.querySelector("img");
                var alt = img && img.alt ? img.alt : "";
                if (href) openLightbox(href, alt);
            });
        });

        closeBtn.addEventListener("click", closeLightbox);
        overlay.addEventListener("click", function (e) {
            if (e.target === overlay) closeLightbox();
        });
        document.addEventListener("keydown", function (e) {
            if (e.key === "Escape") closeLightbox();
        });
    })();
}
